import { FC } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
// components
import ProductTypesSelect from 'components/common/simpleSelectors/ProductType';
// interfaces
import { ProductTypesSelectorProps } from 'interfaces';

const ProductTypesSelector: FC<ProductTypesSelectorProps> = ({ name, title, handleChange, ...rest }) => {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => {
        const { name, onBlur, onChange, value } = field;
        const { error } = fieldState;
        const { message } = error || {};

        return (
          <ProductTypesSelect
            name={name}
            title={title}
            value={value}
            onBlur={onBlur}
            helperText={message}
            error={Boolean(message)}
            handleChange={(val) => {
              onChange(val);
              handleChange && handleChange(val);
            }}
            {...rest}
          />
        );
      }}
    />
  );
};

export default ProductTypesSelector;
